export default "__VITE_ASSET__ChA9AOXu__"